import { z } from 'zod';
export var DomainVerificationFileContentType;
(function (DomainVerificationFileContentType) {
    DomainVerificationFileContentType["Text"] = "text/plain";
    DomainVerificationFileContentType["Json"] = "application/json";
})(DomainVerificationFileContentType || (DomainVerificationFileContentType = {}));
export const domainVerificationFilePathGuard = z
    .string()
    .min(1)
    .max(256)
    .refine((value) => /^\/[\w-][\w.-]*\.[\w-][\w.-]*$/.test(value) ||
    /^\/\.well-known(?:\/[\w-][\w.-]*)+$/.test(value), 'The path must point to a file with an extension at the domain root or to a path under /.well-known/.');
export const domainVerificationFileGuard = z
    .object({
    path: domainVerificationFilePathGuard,
    content: z
        .string()
        .min(1)
        .max(16 * 1024),
    contentType: z.nativeEnum(DomainVerificationFileContentType),
})
    .superRefine(({ content, contentType }, context) => {
    if (contentType !== DomainVerificationFileContentType.Json) {
        return;
    }
    try {
        JSON.parse(content);
    }
    catch {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'The content must be valid JSON for the application/json content type.',
            path: ['content'],
        });
    }
});
export const domainVerificationFilesGuard = domainVerificationFileGuard
    .array()
    .max(10)
    .superRefine((files, context) => {
    const paths = new Set();
    for (const [index, file] of files.entries()) {
        if (paths.has(file.path)) {
            context.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Verification file paths must be unique.',
                path: [index, 'path'],
            });
        }
        paths.add(file.path);
    }
});
export const domainDnsRecordGuard = z.object({
    name: z.string(),
    type: z.string(),
    value: z.string(),
});
export const domainDnsRecordsGuard = domainDnsRecordGuard.array();
// https://developers.cloudflare.com/api/operations/custom-hostname-for-a-zone-list-custom-hostnames#Responses
// Predefine the "useful" fields
export const cloudflareDataGuard = z.object({
    id: z.string(),
    status: z.string(),
    ssl: z.object({
        status: z.string(),
        validation_errors: z
            .object({
            message: z.string(),
        })
            .array()
            .optional(),
    }),
    verification_errors: z.string().array().optional(),
});
export var DomainStatus;
(function (DomainStatus) {
    DomainStatus["PendingVerification"] = "PendingVerification";
    DomainStatus["PendingSsl"] = "PendingSsl";
    DomainStatus["Active"] = "Active";
    DomainStatus["Error"] = "Error";
})(DomainStatus || (DomainStatus = {}));
export const domainStatusGuard = z.nativeEnum(DomainStatus);
